import type { IntelPlatformCreate } from '../../generated/api/types.gen.js';

type PlatformCategory = IntelPlatformCreate['category'];

/** Display order and sentence-case names for the platform categories (the API sends the codes). */
const LABELS: Record<PlatformCategory, string> = {
  social: 'Social',
  on_chain: 'On-chain',
  defi: 'DeFi',
  institutional: 'Institutional',
  research: 'Research',
  market_infra: 'Market infrastructure',
};

export const PLATFORM_CATEGORIES = Object.keys(LABELS) as PlatformCategory[];

export function platformCategoryLabel(category: PlatformCategory): string {
  return LABELS[category];
}
